var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "wm-wrap pa-0", attrs: { fluid: "" } },
    [
      !_vm.weldMappingEnabled
        ? _c(
            "v-alert",
            {
              staticClass: "ma-4",
              attrs: { type: "warning", text: "", prominent: "" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.weldMapping.featureDisabled")) +
                  " "
              ),
            ]
          )
        : [
            _c(
              "div",
              { staticClass: "wm-top" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "wm-ib",
                    attrs: {
                      icon: "",
                      "aria-label": _vm.$t("message.login.back"),
                    },
                    on: { click: _vm.goBack },
                  },
                  [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                  1
                ),
                _c("div", { staticClass: "wm-grow" }, [
                  _c("h1", { staticClass: "wm-h1" }, [
                    _vm._v(_vm._s(_vm.$t("message.weldMapping.title"))),
                  ]),
                  _c("div", { staticClass: "wm-sub" }, [
                    _vm._v(_vm._s(_vm.projectLine)),
                  ]),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "wm-pill",
                    class: _vm.isOnline ? "ok" : "off",
                  },
                  [
                    _c("span", {
                      staticClass: "wm-dot",
                      class: _vm.isOnline ? "g" : "o",
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isOnline
                            ? _vm.$t("message.common.online")
                            : _vm.$t("message.common.offline")
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "wm-pad" },
              [
                _c("v-text-field", {
                  staticClass: "wm-search",
                  attrs: {
                    placeholder: _vm.$t("message.weldMapping.searchDrawing"),
                    "prepend-inner-icon": "mdi-magnify",
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
              ],
              1
            ),
            _vm.stack.length
              ? _c(
                  "div",
                  { staticClass: "wm-crumbs wm-pad" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "wm-crumb",
                        on: { click: _vm.resetLevel },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.allDrawings"))
                        ),
                      ]
                    ),
                    _vm._l(_vm.stack, function (node, i) {
                      return [
                        _c(
                          "span",
                          { key: "s" + i, staticClass: "wm-crumb-sep" },
                          [_vm._v("›")]
                        ),
                        _c(
                          "button",
                          {
                            key: "c" + i,
                            staticClass: "wm-crumb",
                            class: { here: i === _vm.stack.length - 1 },
                            on: {
                              click: function ($event) {
                                return _vm.gotoLevel(i)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.nodeNumber(node)))]
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "wm-pad" },
                  [
                    _c(
                      "v-row",
                      _vm._l(6, function (n) {
                        return _c(
                          "v-col",
                          {
                            key: n,
                            staticClass: "pa-2",
                            attrs: { cols: "12", sm: "6", md: "4" },
                          },
                          [
                            _c("v-skeleton-loader", {
                              attrs: { type: "image, list-item-two-line" },
                            }),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm.loadError
              ? _c(
                  "v-alert",
                  {
                    staticClass: "ma-4",
                    attrs: { type: "error", text: "", prominent: "" },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.loadError) + " "),
                    _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", outlined: "" },
                            on: { click: _vm.loadDrawings },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.common.retry")))]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : [
                  _vm.continueCards.length
                    ? [
                        _c("div", { staticClass: "wm-sec" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(_vm.$t("message.weldMapping.continue"))
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "wm-pad" },
                          _vm._l(_vm.continueCards, function (c) {
                            return _c(
                              "button",
                              {
                                key: c.id,
                                staticClass: "wm-wide",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDrawing(c)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "wm-wide-th" },
                                  [
                                    _vm.hasPreview(c.id)
                                      ? _c("weld-map-canvas", {
                                          attrs: {
                                            preview: "",
                                            joints: _vm.previews[c.id].joints,
                                            "drawing-file":
                                              _vm.previews[c.id].drawing_file,
                                            label: c.number,
                                            "drawing-id": c.id,
                                          },
                                        })
                                      : _c(
                                          "v-icon",
                                          {
                                            staticClass: "wm-ph",
                                            attrs: { size: "30" },
                                          },
                                          [_vm._v("mdi-file-document-outline")]
                                        ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "wm-wide-bd" }, [
                                  _c("div", { staticClass: "wm-no" }, [
                                    _vm._v(_vm._s(c.number)),
                                  ]),
                                  c.description
                                    ? _c("div", { staticClass: "wm-meta" }, [
                                        _vm._v(_vm._s(c.description)),
                                      ])
                                    : _vm._e(),
                                  c.openedAt
                                    ? _c(
                                        "div",
                                        { staticClass: "wm-meta wm-accent" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.weldMapping.lastOpened"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm._f("fromNow")(c.openedAt)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c("v-icon", { staticClass: "wm-ph" }, [
                                  _vm._v("mdi-chevron-right"),
                                ]),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                  _vm.currentOwnWelds > 0
                    ? [
                        _c("div", { staticClass: "wm-sec" }, [
                          _c("h2", [
                            _vm._v(
                              _vm._s(_vm.$t("message.weldMapping.ownJoints"))
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "wm-pad" }, [
                          _c(
                            "button",
                            {
                              staticClass: "wm-wide",
                              on: { click: _vm.openCurrentOwn },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "wm-wide-th" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "wm-ph",
                                      attrs: { size: "30" },
                                    },
                                    [_vm._v("mdi-map-marker-outline")]
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "wm-wide-bd" }, [
                                _c("div", { staticClass: "wm-no" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.ownMap", {
                                        number: _vm.currentNumber,
                                      })
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "wm-meta" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.ownSub", {
                                        count: _vm.currentOwnWelds,
                                      })
                                    )
                                  ),
                                ]),
                              ]),
                              _c("v-icon", { staticClass: "wm-ph" }, [
                                _vm._v("mdi-chevron-right"),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _c("div", { staticClass: "wm-sec" }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(
                          _vm.stack.length
                            ? _vm.$t("message.weldMapping.childDrawings")
                            : _vm.$t("message.weldMapping.allDrawings")
                        )
                      ),
                    ]),
                    _vm.visible.length
                      ? _c("span", { staticClass: "wm-n" }, [
                          _vm._v(_vm._s(_vm.visible.length)),
                        ])
                      : _vm._e(),
                  ]),
                  !_vm.visible.length
                    ? _c("div", { staticClass: "wm-empty" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.search
                                ? _vm.$t("message.weldMapping.noMatch")
                                : _vm.$t(
                                    "message.advancedWeldLog.noDrawingsFound"
                                  )
                            )
                          ),
                        ]),
                        _vm.search
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.noMatchHint")
                                )
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _c(
                        "v-row",
                        { staticClass: "wm-pad ma-0" },
                        _vm._l(_vm.rendered, function (d) {
                          return _c(
                            "v-col",
                            {
                              key: d.id,
                              staticClass: "pa-2",
                              attrs: { cols: "12", sm: "6", md: "4" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "wm-card",
                                  class: {
                                    "wm-card-sel":
                                      _vm.selectedId === d.id && !d.hasChildren,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onCardClick(d)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "wm-th" },
                                    [
                                      _vm.hasPreview(d.id)
                                        ? _c("weld-map-canvas", {
                                            attrs: {
                                              preview: "",
                                              joints: _vm.previews[d.id].joints,
                                              "drawing-file":
                                                _vm.previews[d.id].drawing_file,
                                              label: d.number,
                                              "drawing-id": d.id,
                                            },
                                          })
                                        : _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "34",
                                                color: d.hasChildren
                                                  ? "#8A9099"
                                                  : "#1D6FD6",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    d.hasChildren
                                                      ? "mdi-folder-multiple-outline"
                                                      : "mdi-file-document-outline"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "wm-bd" }, [
                                    _c("div", { staticClass: "wm-no" }, [
                                      _vm._v(_vm._s(d.number)),
                                    ]),
                                    d.description
                                      ? _c("div", { staticClass: "wm-meta" }, [
                                          _vm._v(_vm._s(d.description)),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "wm-meta wm-tags" },
                                      [
                                        d.statusLabel
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "wm-tag",
                                                class: _vm.statusClass(
                                                  d.statusValue,
                                                  d.stage
                                                ),
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(d.statusLabel) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        d.hasChildren
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "wm-tag wm-tag-parent",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.weldMapping.hasChildren",
                                                        { count: d.childCount }
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "wm-foot" },
                                      [
                                        d.weldCount !== null
                                          ? _c("span", [
                                              _c("b", [
                                                _vm._v(_vm._s(d.weldCount)),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.weldMapping.welds"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _c("span"),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "wm-chev",
                                            attrs: { size: "18" },
                                          },
                                          [_vm._v("mdi-chevron-right")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                  _vm.hasMore
                    ? _c(
                        "div",
                        { ref: "sentinel", staticClass: "wm-more" },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: "22",
                              width: "2",
                              color: "#1D6FD6",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticStyle: { height: "24px" } }),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }